import { render } from "./PersonalCenter.vue?vue&type=template&id=4d40f2dc&ts=true"
import script from "./PersonalCenter.ts?vue&type=script&lang=ts&external"
export * from "./PersonalCenter.ts?vue&type=script&lang=ts&external"

import "./PersonalCenter.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__